<template>
    <VehicleConfigurationNav @usage="setUsage" />
  
    <StepsToCalculateNav v-if="!loading" :fuelCost="costDiesel"  :equipment="costEquipment" :otherCost="costOther" :active="0" :usage="currentUsage" />

    <div class="container-fluid" v-if="!loading">
        <div class="row my-5">
            <div class="col-sm-6 vehicle-card-col">
                <VehicleCard :vehicle="vehicleInfo" />
            </div>
            <div class="col-sm-6 text-left vehicle-input-col">
                <p class="heading-3">Fuel Cost Input</p>
                <div class="input-block ">

                    <!-- Miles per year -->
                    <div class="form-group miles-only mt-5" v-if="currentUsage == 'miles'">
                        <label for="dieselMileageYear" class="w-100">Mileage (miles/year)</label>
                        <input type="text" class="range-output output-text" v-model="milesPerYearFormatted" @input="formatInputMiles(); calculateAllSetup()" @change="trackMilesPerYear(milesPerYear)">
                        <input type="number" id="dieselMileageYearOutput" class="range-output d-none" min="0" max="200000" v-model="milesPerYear">
                        <input class="form-control-range" type="range" id="dieselMileageYear" name="dieselMileageYear" min="0" max="200000" v-model="milesPerYear" @input="calculateAllSetup(); formatInputFromSliderMiles()" @change="trackMilesPerYear(milesPerYear)"> 
                    </div>
                    <div class="form-group miles-only mt-5" v-if="currentUsage == 'hours'">
                        <label for="dieselHoursYear" class="w-100">Operating Time (hours/year)</label>
                        <input type="text" class="range-output output-text" v-model="hoursPerYearFormatted" @input="calculateAllSetup()" @change="formatInputHours(); trackHoursPerYear(hoursPerYear)">
                        <input type="number" id="dieselHoursYearOutput" class="range-output d-none" min="0" max="10000" v-model="hoursPerYear">
                        <input class="form-control-range" type="range" id="dieselHoursYear" name="dieselHoursYear" min="0" max="10000" v-model="hoursPerYear" @input="calculateAllSetup(); formatInputFromSliderHours()" @change="trackHoursPerYear(hoursPerYear)"> 
                    </div>

                    <!-- Fuel Cost per Gallon -->
                    <div class="form-group mt-5">
                        <label for="dieselFuelCostGallon" class="w-100">Fuel Cost ($/gallon)</label>
                        <input type="number" id="dieselFuelCostGallonOutput" class="range-output output-text" min="0" max="6" v-model="fuelCostPerGallon" @input="calculateAllSetup()" @change="convertValues(); trackFuelCost(fuelCostPerGallon)">
                        <input class="form-control-range" type="range" id="dieselFuelCostGallon" name="dieselFuelCostGallon" min="0" max="6" step="0.05" v-model="fuelCostPerGallon" @input="convertValues(); calculateAllSetup()" @change="trackFuelCost(fuelCostPerGallon)"> 
                    </div>

                    <!-- Miles Per Gallon -->
                    <div v-if="currentUsage == 'miles'" class="form-group form-group-inline text-input-group mt-5 mb-0">
                        <label for="DieselMilesPerGallon">Miles Per Gallon</label>
                        <input type="number" id="DieselMilesPerGallon" class="range-output" min="1" max="12" v-model="milesPerGallon" @input="calculateAllSetup()" @change="convertValues(); trackMilesPerGallon(milesPerGallon)">
                    </div>

                    <!-- Gallons per hour -->
                    <div v-if="currentUsage == 'hours'" class="form-group form-group-inline text-input-group mt-5 mb-0">
                        <label for="DieselGallonsPerHour">Gallons Per Hour</label>
                        <input type="number" id="DieselGallonsPerHour" class="range-output" min="0" max="25" v-model="gallonsPerHour" @input="calculateAllSetup()" @change="convertValues(); trackGallonsPerHour(gallonsPerHour)">
                    </div>

                </div>

                <div class="text-center next-link position-relative">
                    <router-link to="/diesel/equipment-costs" class="big-link heading-2 text-center" @click="trackNextCategory()">Next Step <img :src="`${imagePath}/arrow-white.png`" alt=""></router-link>
                </div>
            </div>
        </div>
    </div>

    <div class="container-footer" v-if="!loading">
        <div class="container-fluid">
            <div class="row py-4">
                <div class="col-sm-12">
                    <div class="totals-container d-flex w-100 justify-content-between">
                        <div class="totals-item">
                            <p class="text-uppercase">Diesel Costs Total</p>
                            
                            <div class="d-flex justify-content-between">

                                <div class="mr-5" v-if="currentUsage == 'miles'">
                                    <p class="mb-0" id="costPerMileOuput" v-html="formatPrice((totalCostPerMile) * currencyExchange)"></p>
                                    <small>Total Cost Per Mile</small>
                                </div>
                                <div class="mr-5" v-if="currentUsage == 'hours'">
                                    <p class="mb-0" id="costPerMileOuput" v-html="formatPrice((totalCostPerHour) * currencyExchange)"></p>
                                    <small>Total Cost Per Hour</small>
                                </div>

                                <div class="" v-if="currentUsage == 'miles'">
                                    <p class="mb-0" id="annualFuelCostOuput" v-html="formatPrice((totalAnnualCost) * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>
                                <div class="" v-if="currentUsage == 'hours'">
                                    <p class="mb-0" id="annualFuelCostOuput" v-html="formatPrice((totalAnnualCostHourly) * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>

                            </div>
                        </div>

                        <DieselFooter :fuelCost="costDiesel" :equipmentCost="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <DieselSummaryModal :vehicle="vehicleInfo" :fuelCost="costDiesel" :equipment="costEquipment" :otherCost="costOther" :usage="currentUsage" />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import vehicleList from '../services/vehicleList'
    import StepsToCalculateNav from "@/components/StepsToCalculateNav.vue";
    import VehicleConfigurationNav from "@/components/VehicleConfigurationNav.vue";

    import VehicleCard from "../components/VehicleCard"
    import DieselFooter from "../components/DieselFooter"
    import DieselSummaryModal from "../components/DieselSummaryModal"
    

    export default {
        name: 'DieselFuelCosts',
        data () {
            return {
                vehicle: '',
                currentUsage: 'miles', // set as default
                vehicleInfo: {},
                costDiesel: {},
                costEquipment: {},
                costOther: {},
                fuelCost: 10000,
                milesPerYear: 0,
                milesPerYearFormatted: 0,
                hoursPerYear: 0,
                hoursPerYearFormatted: 0,
                fuelCostPerGallon: 0,
                milesPerGallon: 0,
                gallonsPerHour: 0,
                totalAnnualCost: 0,
                totalAnnualCostHourly: 0,
                totalCostPerMile: 0,
                totalCostPerHour: 0,
                currencyType: '',
                currencyExchange: 0,
                currencyConversion: 1,
                loading: true,
                imagePath: process.env.VUE_APP_ASSET_LOCATION
            }
        },
        components: {
            VehicleCard,
            StepsToCalculateNav,
            VehicleConfigurationNav,
            DieselFooter,
            DieselSummaryModal
        },
        created() {
            // For deeplinking. Since we only have 3 vehicles, stamping them out like this is the most maintainable
            if (this.$route.params.vehicle) {
                if (this.$route.params.vehicle == '220') { this.vehicle = 'twoTwenty' }
                if (this.$route.params.vehicle == '520') { this.vehicle = 'fiveTwenty' }
                if (this.$route.params.vehicle == '579') { this.vehicle = 'fiveSeventyNine' }

                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(vehicleList[this.vehicle]['electric']))
                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(vehicleList[this.vehicle]['diesel']))
            }
        },
        mounted() {

            // Grab vehicle info from storage and begin filling in props
            // vehicleInfoHidden is for setting equivalent values for diesel and electric
            this.vehicleInfo = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))
            this.vehicleInfoHidden = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
            this.currentCurrency = sessionStorage.getItem('currency')

            // Set currency
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1
            this.currencyConversion = Number(localStorage.getItem('USDtoCAD'))

            // If US from CA
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'true') {
                this.fuelCostPerGallon = Number(this.vehicleInfo.fuel.fuelCostPerGallon / this.currencyConversion)
            }

            // If CA from US
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'false') {
                this.fuelCostPerGallon = Number(this.vehicleInfo.fuel.fuelCostPerGallon * this.currencyConversion)
            }

            if (sessionStorage.getItem('fromCanada') == null) {
                this.fuelCostPerGallon = this.vehicleInfo.fuel.fuelCostPerGallon
            }

            
            this.milesPerYear = this.vehicleInfo.fuel.mileage 
            this.milesPerYearFormatted = (this.milesPerYear).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.hoursPerYear = this.vehicleInfo.fuel.hours
            this.hoursPerYearFormatted = (this.hoursPerYear).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.milesPerGallon = this.vehicleInfo.fuel.milesPerGallon
            this.gallonsPerHour = this.vehicleInfo.fuel.gallonsPerHour

            this.convertValues()
            this.calculateAllSetup()
            
            this.usToCa = 1.27
            this.gallonToLitre = 3.79
            this.milesToKm = 1.61
            
            this.loading = false

            // Tracking
            // Fire a pageview based on deeplinking vs standard entry
            if (this.$route.params.vehicle) {
                window.gtag('event', 'page_view', {
                    page_title: `Cost Calculator - Diesel ${this.$route.params.vehicle}`,
                    page_location: `/diesel/${this.$route.params.vehicle}`
                })
            }else {
                window.gtag('event', 'page_view', {
                    page_title: 'Cost Calculator - Diesel Fuel Cost',
                    page_location: '/diesel/fuel-costs'
                })
            }
            
        },

        watch: {
            milesPerYearFormatted: function(newValue) {
                const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.milesPerYearFormatted = result)
            },
            hoursPerYearFormatted: function(newValue) {
                const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.hoursPerYearFormatted = result)
            }
        },

        methods: {

            convertValues() {
                this.fuelCostPerGallon = Number(this.fuelCostPerGallon).toFixed(2)
                this.milesPerGallon = Number(this.milesPerGallon).toFixed(2)
                this.gallonsPerHour = Number(this.gallonsPerHour).toFixed(2)
            },

            calculateTotals() {
                // Fuel
                let annualCostOutput = parseFloat((this.milesPerYear / this.milesPerGallon ) * this.fuelCostPerGallon)
                let annualCostOutputHourly = this.hoursPerYear *this.gallonsPerHour * this.fuelCostPerGallon

                // Annual Cost / Mileage
                let costPerMileOutput = annualCostOutput / this.milesPerYear
                let costPerHourOutput = annualCostOutputHourly / this.hoursPerYear

                // Set footer totals
                this.totalAnnualCost = annualCostOutput
                this.totalCostPerMile = costPerMileOutput
                this.totalAnnualCostHourly = annualCostOutputHourly
                this.totalCostPerHour = costPerHourOutput

                sessionStorage.setItem('dieselFuelCost', JSON.stringify({
                        'annual-cost': Number(this.totalAnnualCost), 
                        'cost-per-mile': Number(this.totalCostPerMile),
                        'annual-cost-hourly': Number(this.totalAnnualCostHourly), 
                        'cost-per-hour': Number(this.totalCostPerHour),
                        'mileage': Number(this.milesPerYear),
                        'hours': Number(this.hoursPerYear)
                    })
                )

                
            },
            calculateAllSetup() {
                
                // This Block of variables allows values to persist after going back
                // or after changing from Diesel Electric & vice-versa
                this.vehicleInfo.fuel.mileage = this.milesPerYear
                this.vehicleInfoHidden.fuel.mileage  = this.milesPerYear

                this.vehicleInfo.fuel.hours = this.hoursPerYear
                this.vehicleInfoHidden.fuel.hours = this.hoursPerYear

                this.vehicleInfo.fuel.fuelCostPerGallon = this.fuelCostPerGallon
                this.vehicleInfo.fuel.milesPerGallon = this.milesPerGallon
                this.vehicleInfo.fuel.gallonsPerHour = this.gallonsPerHour
                
                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(this.vehicleInfo))
                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(this.vehicleInfoHidden))

                //prevents mpg from being 0
                if(this.milesPerGallon == 0){
                    this.milesPerGallon = 1
                }

                // Fuel
                let annualCostOutput = parseFloat((this.milesPerYear / this.milesPerGallon ) * this.fuelCostPerGallon)
                let annualCostOutputHourly = this.hoursPerYear * this.gallonsPerHour * this.fuelCostPerGallon

                // Annual Cost / Mileage
                let costPerMileOutput = annualCostOutput / this.milesPerYear
                let costPerHourOutput = annualCostOutputHourly / this.hoursPerYear

                // Set footer totals
                this.totalAnnualCost = annualCostOutput
                this.totalCostPerMile = costPerMileOutput
                this.totalAnnualCostHourly = annualCostOutputHourly
                this.totalCostPerHour = costPerHourOutput

                sessionStorage.setItem('dieselFuelCost', JSON.stringify({
                        'annual-cost': Number(this.totalAnnualCost), 
                        'cost-per-mile': Number(this.totalCostPerMile),
                        'annual-cost-hourly': Number(this.totalAnnualCostHourly), 
                        'cost-per-hour': Number(this.totalCostPerHour),
                        'mileage': Number(this.milesPerYear),
                        'hours': Number(this.hoursPerYear)
                    })
                )

                
                // Equipment
                let totalEquipmentCosts = (this.vehicleInfo['equipment']['vehiclePrice'] - this.vehicleInfo['equipment']['resaleValue'])  / this.vehicleInfo['equipment']['amortization']
                let costPerMileOutputEquipment = totalEquipmentCosts / this.milesPerYear
                let costPerHourOutputEquipment = totalEquipmentCosts / this.hoursPerYear


                sessionStorage.setItem('dieselEquipmentCost', JSON.stringify({
                        'annual-cost': totalEquipmentCosts, 
                        'cost-per-mile': costPerMileOutputEquipment,
                        'cost-per-hour': costPerHourOutputEquipment
                    })
                )

                
                // Other
                let existingStorageOther = JSON.parse(sessionStorage.getItem('dieselOtherCost'))
                let existingStorageOtherElectric = JSON.parse(sessionStorage.getItem('electricOtherCost'))

                let maintenanceCost
                let insuranceCost
                let taxesCost
                let tollsCost
                let driverCost
                let maintenanceCostHourly
                let insuranceCostHourly
                let taxesCostHourly
                let tollsCostHourly
                let driverCostHourly

                let maintenanceCostElectric
                let insuranceCostElectric
                let taxesCostElectric
                let tollsCostElectric
                let driverCostElectric
                let maintenanceCostHourlyElectric
                let insuranceCostHourlyElectric
                let taxesCostHourlyElectric
                let tollsCostHourlyElectric
                let driverCostHourlyElectric

                let modifiedDiesel = false
                let modifiedElectric = false

                // Set values based on storage item (Diesel)
                if (existingStorageOther != null && existingStorageOther.modified == true) {
                    maintenanceCost = Number(existingStorageOther['cost-maintenance'])
                    insuranceCost = Number(existingStorageOther['cost-insurance'])
                    taxesCost = Number(existingStorageOther['cost-taxes'])
                    tollsCost = Number(existingStorageOther['cost-tolls'])
                    driverCost = Number(existingStorageOther['cost-driver'])
                    maintenanceCostHourly = Number(existingStorageOther['cost-maintenance-hourly'])
                    insuranceCostHourly = Number(existingStorageOther['cost-insurance-hourly'])
                    taxesCostHourly = Number(existingStorageOther['cost-taxes-hourly'])
                    tollsCostHourly = Number(existingStorageOther['cost-tolls-hourly'])
                    driverCostHourly = Number(existingStorageOther['cost-driver-hourly'])
                    modifiedDiesel = existingStorageOther.modified
                } else {
                    maintenanceCost = this.vehicleInfo['maintenance']['costPerMile'] * Number(this.milesPerYear)
                    insuranceCost = this.vehicleInfo['insurance']['costPerMile'] * Number(this.milesPerYear)
                    taxesCost = this.vehicleInfo['taxes']['costPerMile'] * Number(this.milesPerYear)
                    tollsCost = this.vehicleInfo['tolls']['costPerMile'] * Number(this.milesPerYear)
                    driverCost = this.vehicleInfo['driver']['driverWagePerMile'] * Number(this.milesPerYear)
                    maintenanceCostHourly = this.vehicleInfo['maintenance']['costPerHour']
                    insuranceCostHourly = this.vehicleInfo['insurance']['costPerHour']
                    taxesCostHourly = this.vehicleInfo['taxes']['costPerHour']
                    tollsCostHourly = this.vehicleInfo['tolls']['costPerHour']
                    driverCostHourly = this.vehicleInfo['driver']['costPerHour']
                }

                // Set values based on storage item (Electric)
                if (existingStorageOtherElectric != null && existingStorageOtherElectric.modified == true) {
                    maintenanceCostElectric = Number(existingStorageOtherElectric['cost-maintenance'])
                    insuranceCostElectric = Number(existingStorageOtherElectric['cost-insurance'])
                    taxesCostElectric = Number(existingStorageOtherElectric['cost-taxes'])
                    tollsCostElectric = Number(existingStorageOtherElectric['cost-tolls'])
                    driverCostElectric = Number(existingStorageOtherElectric['cost-driver'])
                    maintenanceCostHourlyElectric = Number(existingStorageOtherElectric['cost-maintenance-hourly'])
                    insuranceCostHourlyElectric = Number(existingStorageOtherElectric['cost-insurance-hourly'])
                    taxesCostHourlyElectric = Number(existingStorageOtherElectric['cost-taxes-hourly'])
                    tollsCostHourlyElectric = Number(existingStorageOtherElectric['cost-tolls-hourly'])
                    driverCostHourlyElectric = Number(existingStorageOtherElectric['cost-driver-hourly'])
                    modifiedElectric = existingStorageOtherElectric.modified
                } else {
                    maintenanceCostElectric = this.vehicleInfoHidden['maintenance']['costPerMile'] * Number(this.milesPerYear)
                    insuranceCostElectric = this.vehicleInfoHidden['insurance']['costPerMile'] * Number(this.milesPerYear)
                    taxesCostElectric = this.vehicleInfoHidden['taxes']['costPerMile'] * Number(this.milesPerYear)
                    tollsCostElectric = this.vehicleInfoHidden['tolls']['costPerMile'] * Number(this.milesPerYear)
                    driverCostElectric = this.vehicleInfoHidden['driver']['driverWagePerMile'] * Number(this.milesPerYear)
                    maintenanceCostHourlyElectric = this.vehicleInfoHidden['maintenance']['costPerHour']
                    insuranceCostHourlyElectric = this.vehicleInfoHidden['insurance']['costPerHour']
                    taxesCostHourlyElectric = this.vehicleInfoHidden['taxes']['costPerHour']
                    tollsCostHourlyElectric = this.vehicleInfoHidden['tolls']['costPerHour']
                    driverCostHourlyElectric = this.vehicleInfoHidden['driver']['costPerHour']
                }
                
                // calculate new totals
                let totalOtherCosts = Number(maintenanceCost) + Number(insuranceCost) + Number(taxesCost) + Number(tollsCost) + Number(driverCost)
                let totalOtherCostsElectric = Number(maintenanceCostElectric) + Number(insuranceCostElectric) + Number(taxesCostElectric) + Number(tollsCostElectric) + Number(driverCostElectric)
                let totalOtherCostsHourly = Number(maintenanceCostHourly) + Number(insuranceCostHourly) + Number(taxesCostHourly) + Number(tollsCostHourly) + Number(driverCostHourly)
                let totalOtherCostsHourlyElectric = Number(maintenanceCostHourlyElectric) + Number(insuranceCostHourlyElectric) + Number(taxesCostHourlyElectric) + Number(tollsCostHourlyElectric) + Number(driverCostHourlyElectric)
                
                let costPerMileOutputOther = Number(this.milesPerYear) === 0 ? 0 : totalOtherCosts / this.milesPerYear
                let costPerMileOutputOtherElectric = Number(this.milesPerYear) === 0 ? 0 : totalOtherCostsElectric / this.milesPerYear
                let costPerHourOutputOther = totalOtherCostsHourly * this.hoursPerYear
                let costPerHourOutputOtherElectric = totalOtherCostsHourlyElectric * this.hoursPerYear

                sessionStorage.setItem('dieselOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCosts).toFixed(2)), 
                        'annual-cost-hourly': Number((costPerHourOutputOther).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutputOther).toFixed(2)),
                        'cost-maintenance': Number((maintenanceCost).toFixed(2)),
                        'cost-insurance': Number((insuranceCost).toFixed(2)),
                        'cost-taxes': Number((taxesCost).toFixed(2)),
                        'cost-tolls': Number((tollsCost).toFixed(2)),
                        'cost-driver': Number((driverCost).toFixed(2)),
                        'cost-per-hour': Number((totalOtherCostsHourly).toFixed(2)),
                        'cost-maintenance-hourly': Number(maintenanceCostHourly),
                        'cost-insurance-hourly': Number(insuranceCostHourly),
                        'cost-taxes-hourly': Number(taxesCostHourly),
                        'cost-tolls-hourly': Number(tollsCostHourly),
                        'cost-driver-hourly': Number(driverCostHourly),
                        'modified': modifiedDiesel
                    })
                )
                sessionStorage.setItem('electricOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCostsElectric).toFixed(2)), 
                        'annual-cost-hourly': Number((costPerHourOutputOtherElectric).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutputOtherElectric).toFixed(2)),
                        'cost-maintenance': Number((maintenanceCostElectric).toFixed(2)),
                        'cost-insurance': Number((insuranceCostElectric).toFixed(2)),
                        'cost-taxes': Number((taxesCostElectric).toFixed(2)),
                        'cost-tolls': Number((tollsCostElectric).toFixed(2)),
                        'cost-driver': Number((driverCostElectric).toFixed(2)),
                        'cost-per-hour': Number((totalOtherCostsHourlyElectric).toFixed(2)),
                        'cost-maintenance-hourly': Number(maintenanceCostHourlyElectric),
                        'cost-insurance-hourly': Number(insuranceCostHourlyElectric),
                        'cost-taxes-hourly': Number(taxesCostHourlyElectric),
                        'cost-tolls-hourly': Number(tollsCostHourlyElectric),
                        'cost-driver-hourly': Number(driverCostHourlyElectric),
                        'modified': modifiedElectric
                    })
                )
                
                this.costDiesel = JSON.parse(sessionStorage.getItem('dieselFuelCost'))
                this.costEquipment = JSON.parse(sessionStorage.getItem('dieselEquipmentCost'))
                this.costOther = JSON.parse(sessionStorage.getItem('dieselOtherCost'))
                this.fuelCost = annualCostOutput

                this.calculateElectricDefaults()
            },

            // madlad stuff. To account for the Diesel | Electric toggle, we actually have to do the default calculations for the other powertrain as well. Without it, the other powertrain page breaks unless they switch on the Fuel Costs view.
            calculateElectricDefaults() {
                
                let electricVersion = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
                let electricFuelCost = JSON.parse(sessionStorage.getItem('electricFuelCost'))

                let powerConsumption = Number(electricVersion.fuel['powerConsumption'])
                let activeBodyType = (electricFuelCost != null && electricFuelCost.activeBodyType != null) ? electricFuelCost.activeBodyType : {}
                let activeBodyPowerConsumption = 0
                let activeBodyCollectionsPerDay = 50
                let activeBodyIndex = -1
                let PTOOperatingTime = 8
                let PTOOperatingDays = (electricFuelCost != null && electricFuelCost.ptoOperatingDays != null) ? electricFuelCost.ptoOperatingDays : 250
                let pto = 0
                
                // Check for existing data for electric
                if (electricFuelCost != null && electricFuelCost.bodyIndex != null) {
                    activeBodyPowerConsumption = electricFuelCost.bodyIndex == -1 ? 0 : Number(electricVersion.bodyType.bodyParts[electricFuelCost.bodyIndex].bodyPowerConsumption)
                    activeBodyCollectionsPerDay = electricFuelCost.bodyIndex == -1 ? 0 : Number(electricVersion.bodyType.bodyParts[electricFuelCost.bodyIndex].collectionsPerDay)
                    activeBodyIndex = electricFuelCost.bodyIndex == -1 ? -1 : electricFuelCost.bodyIndex
                }

                let annualCostOutput =  this.milesPerYear == 0 ? 0 : parseFloat((Number(electricVersion['fuel']['mileage']) * Number(powerConsumption) * Number(electricVersion['fuel']['electricityCost'])) + 
                (Number(electricVersion['fuel']['electricityCost']) * Number(activeBodyPowerConsumption) * Number(activeBodyCollectionsPerDay) * Number(PTOOperatingDays))) 

                let costPerMileOutput = this.milesPerYear == 0 ? 0 : parseFloat(annualCostOutput / electricVersion['fuel']['mileage'])

                let annualCostOutputHourly = this.hoursPerYear == 0 ? 0 : parseFloat((Number(electricVersion['fuel']['hours']) * Number(powerConsumption) * Number(electricVersion['fuel']['electricityCost'])) + (Number(electricVersion['fuel']['electricityCost']) * Number(activeBodyPowerConsumption) * Number(PTOOperatingTime) * Number(PTOOperatingDays)))
                
                let costPerHourOutput = this.hoursPerYear == 0 ? 0 : parseFloat(annualCostOutput / electricVersion['fuel']['hours'])

                sessionStorage.setItem('electricFuelCost', JSON.stringify({
                        'annual-cost': Number(annualCostOutput), 
                        'cost-per-mile': Number(costPerMileOutput),
                        'annual-cost-hourly': Number(annualCostOutputHourly), 
                        'cost-per-hour': Number(costPerHourOutput),
                        'mileage': Number(electricVersion['fuel']['mileage']),
                        'hours': Number(electricVersion['fuel']['hours']),
                        'powerConsumption': Number(powerConsumption),
                        'pto': Number(pto),
                        'ptoOperatingDays': Number(PTOOperatingDays),
                        'ptoOperatingTime': Number(PTOOperatingTime),
                        'bodyIndex': Number(activeBodyIndex),
                        'activeBodyType': activeBodyType
                    })
                )

                

                
                // Equipment
                let equipmentStorageExists = sessionStorage.getItem('electricEquipmentCost')

                let existingStorageEquipment = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))

                let perCharger = equipmentStorageExists != null ? existingStorageEquipment['per-charger'] : 1
                
                let rebate
                equipmentStorageExists != null ? rebate = existingStorageEquipment['rebate'] : rebate = 0
                
                let amortization
                equipmentStorageExists != null ? amortization = existingStorageEquipment['amortization'] : amortization = electricVersion['equipment']['amortization']

                let totalEquipmentCosts =  (
                    (Number(electricVersion['equipment']['tractorPrice']) - Number(electricVersion['equipment']['resaleValue'])) + 
                    (Number(electricVersion['equipment']['chargerPrice']) / perCharger) - rebate) / Number(amortization)

                let costPerMileOutputEquipment = parseFloat(totalEquipmentCosts / electricVersion['fuel']['mileage']).toFixed(2)
                let costPerHourOutputEquipment = parseFloat(totalEquipmentCosts / electricVersion['fuel']['hours']).toFixed(2)

                sessionStorage.setItem('electricEquipmentCost', JSON.stringify({
                    'annual-cost': Number(totalEquipmentCosts), 
                    'cost-per-mile': Number(costPerMileOutputEquipment),
                    'cost-per-hour': Number(costPerHourOutputEquipment),
                    'vehicle-price': Number(electricVersion['equipment']['tractorPrice']),                    
                    'resale': Number(electricVersion['equipment']['resaleValue']),
                    'charger-price': Number(electricVersion['equipment']['chargerPrice']),
                    'per-charger': perCharger,
                    'rebate': rebate,
                    'amortization': amortization,
                }))

                

                
                // Other
                let existingStorageOther = JSON.parse(sessionStorage.getItem('electricOtherCost'))
                let maintenanceCost
                let insuranceCost
                let taxesCost
                let tollsCost
                let driverCost

                let maintenanceCostHourly
                let insuranceCostHourly
                let taxesCostHourly
                let tollsCostHourly
                let driverCostHourly
                let modified = true

                // Set values based on storage item
                if (existingStorageOther != null && existingStorageOther.modified == true) {
                    maintenanceCost = Number(existingStorageOther['cost-maintenance'])
                    insuranceCost = Number(existingStorageOther['cost-insurance'])
                    taxesCost = Number(existingStorageOther['cost-taxes'])
                    tollsCost = Number(existingStorageOther['cost-tolls'])
                    driverCost = Number(existingStorageOther['cost-driver'])

                    maintenanceCostHourly = Number(existingStorageOther['cost-maintenance-hourly'])
                    insuranceCostHourly = Number(existingStorageOther['cost-insurance-hourly'])
                    taxesCostHourly = Number(existingStorageOther['cost-taxes-hourly'])
                    tollsCostHourly = Number(existingStorageOther['cost-tolls-hourly'])
                    driverCostHourly = Number(existingStorageOther['cost-driver-hourly'])
                } else {
                    maintenanceCost = this.vehicleInfo['maintenance']['costPerMile'] * Number(this.milesPerYear)
                    insuranceCost = this.vehicleInfo['insurance']['costPerMile'] * Number(this.milesPerYear)
                    taxesCost = this.vehicleInfo['taxes']['costPerMile'] * Number(this.milesPerYear)
                    tollsCost = this.vehicleInfo['tolls']['costPerMile'] * Number(this.milesPerYear)
                    driverCost = this.vehicleInfo['driver']['driverWagePerMile'] * Number(this.milesPerYear)

                    maintenanceCostHourly = this.vehicleInfo['maintenance']['costPerHour']
                    insuranceCostHourly = this.vehicleInfo['insurance']['costPerHour']
                    taxesCostHourly = this.vehicleInfo['taxes']['costPerHour']
                    tollsCostHourly = this.vehicleInfo['tolls']['costPerHour']
                    driverCostHourly = this.vehicleInfo['driver']['costPerHour']
                    modified = false
                }
                
                // calculate new totals
                let totalOtherCosts = Number(maintenanceCost) + Number(insuranceCost) + Number(taxesCost) + Number(tollsCost) + Number(driverCost)
                let totalOtherCostsHourly = Number(maintenanceCostHourly) + Number(insuranceCostHourly) + Number(taxesCostHourly) + Number(tollsCostHourly) + Number(driverCostHourly)
                
                let costPerMileOutputOther = Number(this.milesPerYear) === 0 ? 0 : totalOtherCosts / this.milesPerYear
                let costPerHourOutputOther = totalOtherCostsHourly * this.hoursPerYear

                sessionStorage.setItem('electricOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCosts).toFixed(2)), 
                        'annual-cost-hourly': Number((costPerHourOutputOther).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutputOther).toFixed(2)),
                        'cost-maintenance': Number((maintenanceCost).toFixed(2)),
                        'cost-insurance': Number((insuranceCost).toFixed(2)),
                        'cost-taxes': Number((taxesCost).toFixed(2)),
                        'cost-tolls': Number((tollsCost).toFixed(2)),
                        'cost-driver': Number((driverCost).toFixed(2)),
                        'cost-per-hour': Number((totalOtherCostsHourly).toFixed(2)),
                        'cost-maintenance-hourly': Number(maintenanceCostHourly),
                        'cost-insurance-hourly': Number(insuranceCostHourly),
                        'cost-taxes-hourly': Number(taxesCostHourly),
                        'cost-tolls-hourly': Number(tollsCostHourly),
                        'cost-driver-hourly': Number(driverCostHourly),
                        'modified': modified
                    })
                )
                // let maintenanceCost = electricVersion['maintenance']['costPerMile'] * electricVersion['fuel']['mileage']
                // let insuranceCost = electricVersion['insurance']['costPerMile'] * electricVersion['fuel']['mileage']
                // let taxesCost = electricVersion['taxes']['costPerMile'] * electricVersion['fuel']['mileage']
                // let tollsCost = electricVersion['tolls']['costPerMile'] * electricVersion['fuel']['mileage']
                // let driverCost = electricVersion['driver']['driverWagePerMile'] * electricVersion['fuel']['mileage']

                // let maintenanceCostHourly = electricVersion['maintenance']['costPerHour']
                // let insuranceCostHourly = electricVersion['insurance']['costPerHour']
                // let taxesCostHourly = electricVersion['taxes']['costPerHour']
                // let tollsCostHourly = electricVersion['tolls']['costPerHour']
                // let driverCostHourly = electricVersion['driver']['costPerHour']
                
                
                // let totalOtherCosts = maintenanceCost + insuranceCost + taxesCost + tollsCost + driverCost
                // let totalOtherCostsHourly = (maintenanceCostHourly + insuranceCostHourly + taxesCostHourly + tollsCostHourly + driverCostHourly)
                
                // let costPerMileOutputOther = totalOtherCosts / electricVersion['fuel']['mileage']
                // let costPerHourOutputOther = totalOtherCostsHourly * electricVersion['fuel']['hours']

                // sessionStorage.setItem('electricOtherCost', JSON.stringify({
                //         'annual-cost': Number(totalOtherCosts), 
                //         'cost-per-mile': Number(costPerMileOutputOther),
                //         'cost-maintenance': Number(maintenanceCost),
                //         'cost-insurance': Number(insuranceCost),
                //         'cost-taxes': Number(taxesCost),
                //         'cost-tolls': Number(tollsCost),
                //         'cost-driver': Number(driverCost),
                //         'annual-cost-hourly': Number(costPerHourOutputOther), 
                //         'cost-per-hour': Number(totalOtherCostsHourly),
                //         'cost-maintenance-hourly': Number(maintenanceCostHourly),
                //         'cost-insurance-hourly': Number(insuranceCostHourly),
                //         'cost-taxes-hourly': Number(taxesCostHourly),
                //         'cost-tolls-hourly': Number(tollsCostHourly),
                //         'cost-driver-hourly': Number(driverCostHourly)
                //     })
                // )
            },

            // Sets Miles or Hours calculations based on selection in navigation
            setUsage(value) {
                (sessionStorage.getItem('usage') == null || sessionStorage.getItem('usage').length === 0) ? this.currentUsage = this.currentUsage : this.currentUsage = value
                //this.calculateAllSetup()
                this.calculateTotals()
            },

            // Formatting for inputs
            formatInputMiles() {
                this.milesPerYearFormatted = this.milesPerYearFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.milesPerYear = Number(this.milesPerYearFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderMiles() {
                this.milesPerYearFormatted = this.milesPerYear.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            formatInputHours() {
                this.hoursPerYearFormatted = this.hoursPerYearFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.hoursPerYear = Number(this.hoursPerYearFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderHours() {
                this.hoursPerYearFormatted = this.hoursPerYear.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            formatPrice(value, spaces = 2) {
                let val = (value/1).toFixed(spaces)
                if(isNaN(val)) {
                    return '$0.00'
                } else {
                    return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
            },
            trackNextCategory() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Next Category',
                    'event_label': this.$route.path
                })
            },
            trackMilesPerYear(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Diesel Fuel Cost',
                    'event_label': 'Mileage ' + value
                })
            },
            trackHoursPerYear(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Diesel Fuel Cost',
                    'event_label': 'Operating Time ' + value
                })
            },
            trackFuelCost(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Diesel Fuel Cost',
                    'event_label': 'Fuel Cost ' + value
                })
            },
            trackMilesPerGallon(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Diesel Fuel Cost',
                    'event_label': 'Miles Per Gallon ' + value
                })
            },
            trackGallonsPerHour(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Diesel Fuel Cost',
                    'event_label': 'Gallons Per Hour ' + value
                })
            }
        }
    }
</script>